import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/news/detail/page";
import PopularMovies from "../pages/movies/popular/page";
import CategoryPage from "../pages/movies/category/page";
import MovieDetail from "../pages/movie/detail/page";
import SearchPage from "../pages/search/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "movies/popular", element: <PopularMovies /> },
      { path: "movies/category/:type", element: <CategoryPage /> },
      { path: "movie/:id", element: <MovieDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;